import React from "react";
import { ListboxOption } from "@headlessui/react";
import { classNames } from "../../../helpers/classNames";
import Scrollbars from "react-custom-scrollbars-2";

const SingleDropdown = ({
  timeDropdownData,
  selectedHour,
  selectedMinute,
  selectedSecond,
  format,
  selectedTimeAt,
  selectedTimeZone,
}) => {
  return (
    <div className="flex w-full">
      {Object.keys(timeDropdownData).map((key, i) => (
        <Scrollbars
          autoHide
          key={i?.toString()}
          style={{ width: 66, height: 200 }}
          className={classNames(
            `my-1`,
            i + 1 !== Object.keys(timeDropdownData)?.length &&
              "border-r border-opplio-border/50"
          )}
        >
          {timeDropdownData[key]?.map((unit, index) => (
            <ListboxOption
              key={index?.toString()}
              className={({ active }) => ``}
              value={{ [key]: unit }}
            >
              {({ selected, active }) => (
                <>
                  <div
                    className={classNames(
                      `block truncate rounded px-2 py-1 hover:bg-[#0000000a] text-center text-sm text-[#000000e0] font-normal cursor-pointer`,
                      key === "hours" && selectedHour === unit
                        ? "!bg-chestnut-rose/70 !text-white"
                        : key === "minutes" && selectedMinute === unit
                        ? "!bg-chestnut-rose/70 !text-white"
                        : key === "seconds" && selectedSecond === unit
                        ? "!bg-chestnut-rose/70 !text-white"
                        : format === 12 &&
                          selectedTimeAt === unit &&
                          "!bg-chestnut-rose/70 !text-white"
                    )}
                  >
                    {unit}
                  </div>
                </>
              )}
            </ListboxOption>
          ))}
        </Scrollbars>
      ))}
    </div>
  );
};

export default SingleDropdown;
